import castPath from "./component-library360.mjs";
import toKey from "./component-library325.mjs";
function baseGet(object, path) {
  path = castPath(path, object);
  var index = 0, length = path.length;
  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return index && index == length ? object : void 0;
}
export {
  baseGet as default
};
